import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { BaseView } from '@/components/base'
import { RowItem } from '@/components/RowItem'
import { useGetMe } from '@/domain/identity/useCases'
import { Edit } from '@/assets/icons'
import { useTheme } from '@/hooks/useTheme'

export const PersonalInfos: React.FC = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { data: userData, isLoading: isLoadingUserData } = useGetMe()

  const handlePressEdit = () => {
    // Navigate to edit legal name screen (similar to RN version)
    const params = new URLSearchParams({
      firstName: userData?.first_name || '',
      lastName: userData?.last_name || '',
    })
    navigate(`/kem-card/update-legal-name?${params.toString()}`)
  }

  const separatorStyle: React.CSSProperties = {
    backgroundColor:
      theme.colors.background.semiTransparent || 'rgba(255, 255, 255, 0.1)',
    height: '2px',
    borderRadius: '2px',
    width: '100%',
  }

  const fullName =
    userData?.first_name && userData?.last_name
      ? `${userData.first_name} ${userData.last_name}`
      : t('common:unavailable', 'Unavailable')

  const phoneNumber =
    userData?.phone_number || t('common:notProvided', 'Not provided')
  const email = userData?.email || t('common:notProvided', 'Not provided')

  const phoneNumberLabel = userData?.phone_number
    ? t('common:phoneNumber', 'Phone number')
    : `${t('common:phoneNumber', 'Phone number')} (optional)`
  const emailLabel = userData?.email
    ? t('common:email', 'Email')
    : `${t('common:email', 'Email')} (optional)`
  return (
    <>
      {/* Top Separator */}
      <BaseView style={separatorStyle} />

      <BaseView gap={15} style={{ padding: '0 4px' }}>
        {/* Name Row with Edit Icon */}
        <RowItem
          label={t('translation:yourName', 'Your name')}
          value={fullName}
          skeletonActive={isLoadingUserData}
          labelProps={{
            color: 'label.description',
            fontFamily: 'regular',
            fontSize: 16,
          }}
          valueProps={{
            color: 'label.default',
            fontFamily: 'medium',
            fontSize: 16,
          }}
          IconComponent={
            !isLoadingUserData ? (
              <BaseView
                onClick={handlePressEdit}
                style={{
                  cursor: 'pointer',
                  padding: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Edit color={theme.colors.icon.primary} size={16} />
              </BaseView>
            ) : undefined
          }
        />

        {/* Phone Number Row */}
        {userData?.phone_number ? (
          <RowItem
            label={phoneNumberLabel}
            value={phoneNumber}
            skeletonActive={isLoadingUserData}
            labelProps={{
              color: 'label.description',
              fontFamily: 'regular',
              fontSize: 16,
            }}
            valueProps={{
              color: 'label.default',
              fontFamily: 'medium',
              fontSize: 16,
            }}
          />
        ) : (
          <RowItem
            label={emailLabel}
            value={email}
            skeletonActive={isLoadingUserData}
            labelProps={{
              color: 'label.description',
              fontFamily: 'regular',
              fontSize: 16,
            }}
            valueProps={{
              // color: 'label.clickable',
              fontFamily: 'medium',
              fontSize: 16,
              style: {
                // cursor: 'pointer',
                // pointerEvents: 'all',
              },
            }}
            // valueOnClick={() => {
            //   navigate('/add-email')
            // }}
          />
        )}
        {userData?.phone_number ? (
          <RowItem
            label={emailLabel}
            value={email}
            skeletonActive={isLoadingUserData}
            labelProps={{
              color: 'label.description',
              fontFamily: 'regular',
              fontSize: 16,
            }}
            valueProps={{
              color: 'label.default',
              fontFamily: 'medium',
              fontSize: 16,
            }}
          />
        ) : (
          <RowItem
            label={phoneNumberLabel}
            value={phoneNumber}
            skeletonActive={isLoadingUserData}
            labelProps={{
              color: 'label.description',
              fontFamily: 'regular',
              fontSize: 16,
            }}
            valueProps={{
              // color: 'label.clickable',
              fontFamily: 'medium',
              fontSize: 16,
              // style: {
              //   cursor: 'pointer',
              //   pointerEvents: 'all',
              // },
            }}
            // valueOnClick={() => {
            //   navigate('/add-phone')
            // }}
          />
        )}
      </BaseView>

      {/* Bottom Separator */}
      <BaseView style={separatorStyle} />
    </>
  )
}
